import * as React from "react";
import {FieldValues, useFormContext, Validate} from "react-hook-form";
import {FloatingLabel, Form} from "react-bootstrap";
import {ValidationMessage} from "./validationMessage";

interface IProps {
    fieldName: string;
    displayName?: string;
    placeholder?: string;
    rows: number;
    size?: 'sm' | 'lg';
    readonly?: boolean;
    disabled?: boolean;
    validation: {
        enabled: boolean;
        rules?: Validate<any, FieldValues> | Record<string, Validate<any, FieldValues>> | undefined
    };
    minLength?: number;
    maxLength: number;
    required: boolean;
    defaultValue?: string | number;
    className?: string;
    type?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const TextArea = (props: IProps) => {
    const normalizedMinLength = props.minLength ?? 0;
    const {register, formState: {errors}} = useFormContext();

    // Default to disabled to false if not specified
    const disabled = props.disabled ?? false;

    return (
        <>
            <FloatingLabel controlId={props.fieldName} label={props.placeholder ?? props.fieldName}>
                <Form.Control
                    {...register(props.fieldName, {
                        required: {
                            value: props.validation.enabled && props.required,
                            message: `${props.displayName ?? props.fieldName} is required.`
                        },
                        minLength: {
                            value: normalizedMinLength,
                            message: `${props.displayName ?? props.fieldName} has a minimum length of ${normalizedMinLength} characters.`
                        },
                        maxLength: {
                            value: props.maxLength,
                            message: `${props.displayName ?? props.fieldName} has a maximum length of ${props.maxLength} characters.`
                        },
                        validate: props.validation.enabled ? {
                            ...props.validation.rules
                        } : {}
                    })}
                    type={props.rows === 1 ? "textarea" : undefined}
                    as={props.rows != 1 ? "textarea" : undefined}
                    rows={props.rows != 1 ? props.rows : undefined}
                    size={props.size}
                    defaultValue={props.defaultValue}
                    aria-invalid={errors[props.fieldName] ? "true" : "false"}
                    className={`${errors[props.fieldName] ? 'form-error-border' : ''}${disabled ? ` readonly` : ''}${props.className ? ` ${props.className}` : ''}`}
                    placeholder={props.placeholder}
                    readOnly={props.readonly ?? false}
                    onChange={props.onChange}
                    disabled={disabled}
                />
            </FloatingLabel>
            <ValidationMessage fieldName={props.fieldName}/>
        </>
    );
};
